"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Layout extends React.Component {
    get siteConfig() {
        return this.props.data.siteConfig;
    }
    render() {
        this.loadStyle();
        const content = this.props.children();
        return (React.createElement("div", { className: "app" }, this.renderBody(content)));
    }
    renderBody(content) {
        return content;
    }
}
exports.Layout = Layout;



// WEBPACK FOOTER //
// ./src/core/base/Layout.tsx